// extracted by mini-css-extract-plugin
export default {"p_tye":"_64223abcea","slcted":"a8acde5a91","slc_color":"_87b60b5b43","item_p":"_688dd6dfd1","r0":"bb93d954d6"};